import type { ReactNode } from "react";
import Navbar from "@/components/Navbar";
import { useMinhaAreaLayout } from "@/hooks/useMinhaAreaLayout";
import { useAuthState } from "@/hooks/useAuthState";
import { cn } from "@/lib/utils";

type MinhaAreaPageShellProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
};

/**
 * Envolve páginas que podem ser acessadas em /minha-area (layout com Navbar+banner)
 * ou em rota avulsa (ex.: /mensagens) com Navbar próprio.
 */
export function MinhaAreaPageShell({
  children,
  className,
  contentClassName = "container mx-auto px-4 py-8",
}: MinhaAreaPageShellProps) {
  const inLayout = useMinhaAreaLayout();
  const { isAuthenticated, userType, userName, userPhoto, userId } = useAuthState();

  if (inLayout) {
    return <div className={cn(contentClassName)}>{children}</div>;
  }

  return (
    <div className={cn("min-h-screen bg-background", className)}>
      <Navbar
        isAuthenticated={isAuthenticated}
        isOwner={userType === "owner"}
        userName={userName}
        userPhoto={userPhoto}
        userId={userId}
        userType={userType}
      />
      <div className={contentClassName}>{children}</div>
    </div>
  );
}
